import { Component, EventEmitter, OnInit, Output, forwardRef } from '@angular/core';
import { SmUiComponent } from '../sm-ui/sm-ui.component';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-sm-toggle',
  templateUrl: './sm-toggle.component.html',
  styleUrls: ['./sm-toggle.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SmToggleComponent),
            multi: true
        }
    ]
})
export class SmToggleComponent extends SmUiComponent implements OnInit {
  @Output() checked = new EventEmitter<any>();
    override ngOnInit(): void {
    }
    toggleEmitter(event): void {
        this.checked.emit(event.target.checked);
    }
}
